import Toast, { useToast } from 'vue-toastification'

const toastOptions = {
  position: 'bottom-left',
  type: 'info',
  rtl: true,
  timeout: 5000,
  closeOnClick: true,
  pauseOnHover: true,
  showCloseButtonOnHover: true,
  // container: asyncGetContainer,
  newestOnTop: true,
  maxToasts: 9,
  transition: 'Vue-Toastification__fade',
  draggable: true,
  pauseOnFocusLoss: true,
  hideProgressBar: false,
  toastClassName: [],
  bodyClassName: [],
  onMounted: undefined,
}

const toastInstance = useToast(toastOptions)

export { toastInstance, toastOptions }
export default Toast